import { createRoot } from 'react-dom/client'
import App, { preloadRoute } from './App.tsx'
// Import main CSS - Vite will automatically inject it
import './index.css'

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error('Root element not found');
}

// Load the current page's chunk first, so React's first commit replaces the
// prerendered HTML with the same page rather than with a loading fallback.
// A failed chunk load still renders; the route's Suspense boundary takes over.
preloadRoute(window.location.pathname)
  .catch(() => undefined)
  .then(() => {
    createRoot(rootElement).render(<App />);
  });
